<app-title-bar titleText="i18n.core.navigation.brand-logos"></app-title-bar>
<div class="row">
  <div class="col-12 mb-2">
    <button class="btn btn-primary me-2 btn-fixedw rounded right"
            type="button"
            [disabled]="selectedBrandLogos.length === 0"
            (click)="assignLogos()">
      <span class="e-icons icon-cloud--upload"></span>
      {{ 'i18n.domain.assets.brand-logos.assign-logos' | translate }}
    </button>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <ejs-grid #grid
              class="grid-with-toolbar grid-configuration"
              width="100%"
              rowHeight="38"
              [dataSource]="data"
              [allowPaging]="true"
              [pageSettings]='pageSettings'
              [allowSorting]="true"
              [allowFiltering]="true"
              [filterSettings]="filterSettings"
              (actionBegin)="actionBegin($event)"
              (actionComplete)="actionComplete($event)"
              (dataBound)="dataBound()"
              (commandClick)="commandClick($event)"
              (rowSelecting)="filterRowSelection($event)"
              (rowDeselecting)="filterRowSelection($event)"
              (rowSelected)="rowSelectedChanged()"
              (rowDeselected)="rowSelectedChanged()"
              (rowDataBound)="onRowDataBound($event)">
      <e-columns>
        <e-column type='checkbox' width='50'></e-column>
        <e-column field="fileLink"
                  headerText="{{'i18n.domain.assets.brand-logos.grid.preview' | translate}}"
                  [allowFiltering]="false"
                  [allowSorting]="false">
          <ng-template #template let-data>
            @if(data.fileLink){
              <div class="asset-preview">
                <a [href]="data.fileLink" target="_blank" (click)="$event?.stopPropagation()">
                  <img src="{{data.fileLink}}" [alt]="data.altText ?? ('i18n.domain.assets.product-assets.subgrid.image-not-available' | translate)"/>
                </a>
              </div>
            }
          </ng-template>
        </e-column>
        <e-column field="brand"
                  [isPrimaryKey]="true"
                  headerText="{{'i18n.domain.assets.brand-logos.grid.brand' | translate}}"
                  clipMode="EllipsisWithTooltip">
        </e-column>
        <e-column field="brandSub"
                  type="string"
                  headerText="{{'i18n.domain.assets.brand-logos.grid.subbrand' | translate}}"
                  clipMode="EllipsisWithTooltip">
        </e-column>
        <e-column field="publicName"
                  type="string"
                  headerText="{{'i18n.domain.assets.brand-logos.grid.public-name' | translate}}"
                  clipMode="EllipsisWithTooltip">
        </e-column>
        <e-column field="originalFileName"
                  type="string"
                  headerText="{{'i18n.domain.assets.brand-logos.grid.original-file-name' | translate}}"
                  clipMode="EllipsisWithTooltip">
        </e-column>
        <e-column field="shops"
                  [allowFiltering]="false"
                  [allowSorting]="false"
                  headerText="{{'i18n.domain.assets.brand-logos.grid.shops' | translate}}"
                  clipMode="EllipsisWithTooltip">
          <ng-template #template let-data>
            <div>
              {{ getShopNames(data.shops) }}
            </div>
          </ng-template>
        </e-column>
        <e-column headerText="" [commands]='gridCommands'></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</div>

<app-brand-logos-edit-form (OnClose)="grid.refresh()"></app-brand-logos-edit-form>

<app-brand-logos-delete-dialog (OnClose)="grid.refresh()" [isBrandLogo]="isDeleteLogoBrandLogo"></app-brand-logos-delete-dialog>
